// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import AccountEditScreen from "../../src/screens/accounts/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} AccountNewRouteProps */

/** @typedef {Record<string, never>} AccountNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<AccountNewRouteProps, AccountNewRouteState>}
 */
class AccountNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New account")}</ScreenTitle>
        <AccountEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<AccountNewRouteProps>} */
const AccountNewRouteComponent = memo(shapeComponent(AccountNewRoute))

export default AccountNewRouteComponent
